
// INFORMAÇÕES DO SITE
export const SITE_TITLE = 'PROAD'
export const SITE_DESC = 'Website da Pró-Reitoria de Administração da UFRN'
export const SITE_AUTHOR = 'SINFO - Superintendência de informática'
export const SITE_ANALYTICS = 'UA-82625671-6'

// URLs Úteis de Acesso à APIs
export const WP_URL_PROD = 'https://webcache02-producao.info.ufrn.br/admin/proad/wp-json/wp/v2/'
export const WP_URL_DEV = 'https://sites-testes.info.ufrn.br/GerenciadorWP/proad/wp-json/wp/v2/'
export const WP_URL = (process.env.NODE_ENV === 'production') ? WP_URL_PROD : WP_URL_DEV

// URL envio de e-mail
export const URL_ENVIA_EMAIL_PROD = 'https://baldur.info.ufrn.br/ufrncontato/proad/envia_email.php'
export const URL_ENVIA_EMAIL_DEV = 'https://sites-testes.info.ufrn.br/envio-email-ufrn/proad/envia_email.php'
export const URL_ENVIA_EMAIL = (process.env.NODE_ENV === 'production') ? URL_ENVIA_EMAIL_PROD : URL_ENVIA_EMAIL_DEV

// URL base utilizada na página de busca, lembrar de trocar de acordo com o ambiente utilizado
export const URL_BASE = '/'



// WEBPACK FOOTER //
// ./src/js/config.js